import React from 'react';
import { Link } from 'react-router-dom';
import { capitalize } from 'lodash-es';
import { map } from 'lodash-es';

import './nav.scss';

export default class Nav extends React.Component {
  _userList() {
    return map(this.props.users, (user, i) => {
      return (
        <li key={ i } className="nav-list-item">
          <Link to={`/${user.name}`} className="nav-list-item-link">{ capitalize(user.name) }</Link>
        </li>
      );
    });
  }

  render() {
    return (
      <ul className="nav-list">
        { this._userList() }
      </ul>
    );
  }
}
